var map = {
	"./alert.svg": "b51f",
	"./avatar.svg": "8fef",
	"./badge.svg": "11f5",
	"./breadcrumb.svg": "5fcc",
	"./buttons.svg": "71d4",
	"./card.svg": "9905",
	"./carousel.svg": "6984",
	"./checkbox.svg": "1ad7",
	"./collapse.svg": "6ece",
	"./drawer.svg": "7135",
	"./dropdown.svg": "2d53",
	"./form.svg": "6336",
	"./icon.svg": "f049",
	"./input-number.svg": "dbe2",
	"./input.svg": "7330",
	"./list.svg": "4111",
	"./menu.svg": "15fe",
	"./modal.svg": "8d65",
	"./notification.svg": "41fd",
	"./pagination.svg": "4be4",
	"./popover.svg": "b566",
	"./progress.svg": "8295",
	"./radio.svg": "c9a9f",
	"./select.svg": "1cc6",
	"./slider.svg": "ee5f",
	"./spinner.svg": "be1e",
	"./steps.svg": "8c10",
	"./switch.svg": "ec1c",
	"./table.svg": "bca4",
	"./tabs.svg": "a3f9",
	"./tooltip.svg": "82263",
	"./typography.svg": "df74"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2399";